// extracted by mini-css-extract-plugin
var _1 = "page_actionsButtonsWrapper__Akeeg";
var _2 = "page_label__O49NT";
var _3 = "page_spacer__5j-xW";
var _4 = "page_title__DQVKo";
var _5 = "page_workBreaks__lcTSt";
export { _1 as "actionsButtonsWrapper", _2 as "label", _3 as "spacer", _4 as "title", _5 as "workBreaks" }
